import type { CameraRequest } from "@/domains/requests/api/types";

const COMMON_REQUESTER = {
  lastName: "Hendrickx",
  firstName: "Maarten",
  email: "maarten.hendrickx@police.belgium.eu",
  phone: "+32 471 12 34 56",
  service: "Wijkteam Antwerpen-Noord",
  serviceContactDetails: "wijkteam.noord@police.belgium.eu — +32 3 222 22 22",
} as const;

export const SEED_REQUESTS: ReadonlyArray<CameraRequest> = [
  {
    id: "req-9214",
    number: "AANV-2026-9214",
    title: "Overlast De Coninckplein",
    status: "approved",
    requesterId: "u-maarten",
    submittedAt: "2026-04-28T09:14:00",
    requester: COMMON_REQUESTER,
    assets: [
      { id: "line-9214-1", assetType: "camera", quantity: 1, note: "Vaste camera op bestaande paal." },
      { id: "line-9214-2", assetType: "batteryPack", quantity: 1, note: "Voor duurtijd inzet." },
    ],
    period: {
      startDate: "2026-05-05",
      deploymentStart: "2026-05-05",
      endDate: "2026-05-19",
      extensionPossible: true,
    },
    location: {
      address: "De Coninckplein 1, 2060 Antwerpen",
      locationAndCameraDirection:
        "Camera richten op het plein richting Lange Beeldekensstraat — focus op toegangen vanuit het zuiden.",
      polePresence: "yes",
      photos: [
        {
          id: "ph-9214-1",
          filename: "de-coninckplein-overzicht.jpg",
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/De_Coninckplein_2.jpg/960px-De_Coninckplein_2.jpg",
          cameraDirection: "Plein vanuit noordoost richting Lange Beeldekensstraat",
        },
      ],
      environmentalFactors:
        "Verlichting aanwezig, hoge gebouwen rondom, geen overhangende takken.",
    },
    extraInfo: {
      event: "Nee",
      eventInfo: "",
      parkingSigns: "Niet vereist — plaatsing op bestaande paal.",
    },
    motivation: {
      reason:
        "Aanhoudende overlast (drugs- en geluidsmeldingen) sinds 4 maanden — gestructureerde observatie nodig.",
      pvNumber: "PV-2026-A-12345",
      specialAuthorization:
        "Bestuurlijke maatregel — Burgemeester (bestuurlijke maatregel), dossier BM-2026-088",
      multipleDeployment:
        "Eveneens 1 batterij pack noodzakelijk i.f.v. de duurtijd van de inzet.",
      complianceConfirmed: true,
    },
    qualityConfirmed: true,
    caseId: "case-9214",
  },
  {
    id: "req-9221",
    number: "AANV-2026-9221",
    title: "Cameratoezicht Groenplaats",
    status: "approved",
    requesterId: "u-maarten",
    submittedAt: "2026-05-02T11:42:00",
    requester: COMMON_REQUESTER,
    assets: [
      { id: "line-9221-1", assetType: "camera", quantity: 1 },
    ],
    period: {
      startDate: "2026-05-08",
      endDate: "2026-05-15",
      extensionPossible: false,
    },
    location: {
      address: "Groenplaats, 2000 Antwerpen",
      locationAndCameraDirection:
        "Camera op bestaande paal aan zijde Suikerrui — richting Onze-Lieve-Vrouwekathedraal.",
      polePresence: "yes",
      photos: [
        {
          id: "ph-9221-1",
          filename: "groenplaats-kathedraal.jpg",
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Antwerpen%2C_Liebfrauenkathedrale.jpg/1280px-Antwerpen%2C_Liebfrauenkathedrale.jpg",
          cameraDirection: "Vanaf Suikerrui richting Onze-Lieve-Vrouwekathedraal",
        },
      ],
      environmentalFactors: "Druk toeristisch gebied, festivalseizoen.",
    },
    extraInfo: {
      event: "Ja",
      eventInfo: "Festival 'Stad in Beweging' op zaterdag 9 mei tussen 14u-22u.",
      parkingSigns: "Geen plaatsing van parkeerborden vereist.",
    },
    motivation: {
      reason:
        "Risico op zakkenrollers en georganiseerde overlast tijdens festival. Preventief cameratoezicht gevraagd.",
      pvNumber: "",
      specialAuthorization: "Niet van toepassing — preventieve inzet.",
      multipleDeployment: "Enkel 1 camera.",
      complianceConfirmed: true,
    },
    qualityConfirmed: true,
    caseId: "case-9221",
  },
  {
    id: "req-9223",
    number: "AANV-2026-9223",
    title: "Camera Sint-Jansvliet",
    status: "approved",
    requesterId: "u-maarten",
    submittedAt: "2026-04-30T08:55:00",
    requester: COMMON_REQUESTER,
    assets: [
      { id: "line-9223-1", assetType: "camera", quantity: 1 },
    ],
    period: {
      startDate: "2026-05-04",
      deploymentStart: "2026-05-04",
      endDate: "2026-05-18",
      extensionPossible: true,
    },
    location: {
      address: "Sint-Jansvliet 19, 2000 Antwerpen",
      locationAndCameraDirection:
        "Vaste camera tegenover Brouwershuis, kijkrichting noordoost richting toegang Pelgrimstraat.",
      polePresence: "yes",
      photos: [
        {
          id: "ph-9223-1",
          filename: "sint-jansvliet-brouwershuis.jpg",
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/%22Brouwershuis%22_of_%22Waterhuis%22_2012-09-25_07-43-27.jpg/500px-%22Brouwershuis%22_of_%22Waterhuis%22_2012-09-25_07-43-27.jpg",
          cameraDirection: "Zicht op Brouwershuis vanaf overzijde Sint-Jansvliet",
        },
      ],
      environmentalFactors:
        "Smalle straten, beperkte verlichting na 22u, weinig doorgaand verkeer.",
    },
    extraInfo: {
      event: "Nee",
      eventInfo: "",
      parkingSigns: "Niet vereist.",
    },
    motivation: {
      reason:
        "Gerichte observatie in kader van lopend gerechtelijk onderzoek — verzoek onderzoeksrechter.",
      pvNumber: "PV-2026-A-13901",
      specialAuthorization: "Vertrouwelijk — dossiernr. OR-2026-447.",
      multipleDeployment: "1 mobiele camera, geen extra toebehoren.",
      complianceConfirmed: true,
    },
    qualityConfirmed: true,
    caseId: "case-9223",
  },
  {
    id: "req-9225",
    number: "AANV-2026-9225",
    title: "Mobile tree Operaplein",
    status: "approved",
    requesterId: "u-maarten",
    submittedAt: "2026-05-04T13:10:00",
    requester: COMMON_REQUESTER,
    assets: [
      { id: "line-9225-1", assetType: "mobileTree", quantity: 1 },
      { id: "line-9225-2", assetType: "batteryPack", quantity: 1 },
    ],
    period: {
      startDate: "2026-05-09",
      deploymentStart: "2026-05-09",
      endDate: "2026-05-23",
      extensionPossible: true,
    },
    location: {
      address: "Operaplein, 2018 Antwerpen",
      locationAndCameraDirection:
        "Mobile tree centraal op het plein, panoramisch zicht richting Vlaamse Opera en Frankrijklei.",
      polePresence: "needsToBePlaced",
      photos: [
        {
          id: "ph-9225-1",
          filename: "operaplein-vlaamse-opera.jpg",
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Antwerpen_Opera.JPG/1280px-Antwerpen_Opera.JPG",
          cameraDirection: "Mobile tree richting Vlaamse Opera",
        },
      ],
      environmentalFactors:
        "Open plein, veel passanten tijdens Sinksenfoor, geen schaduw of obstakels.",
    },
    extraInfo: {
      event: "Ja",
      eventInfo: "Opstart Sinksenfoor — wekenlange volkstoeloop verwacht.",
      parkingSigns: "Parkeerverbod te voorzien rond de opstelplaats van de mobile tree.",
    },
    motivation: {
      reason:
        "Cameratoezicht tijdens opstart Sinksenfoor — preventie zakkenrollerij en crowd management.",
      pvNumber: "",
      specialAuthorization: "Niet van toepassing.",
      multipleDeployment: "1 mobile tree + 1 batterij pack.",
      complianceConfirmed: true,
    },
    qualityConfirmed: true,
    caseId: "case-9225",
  },
  {
    id: "req-9227",
    number: "AANV-2026-9227",
    title: "Camcar Sportpaleis",
    status: "approved",
    requesterId: "u-maarten",
    submittedAt: "2026-05-06T15:20:00",
    requester: COMMON_REQUESTER,
    assets: [
      { id: "line-9227-1", assetType: "camcar", quantity: 1, note: "Opstelling parking P2." },
    ],
    period: {
      startDate: "2026-05-11",
      deploymentStart: "2026-05-11",
      endDate: "2026-05-13",
      extensionPossible: false,
    },
    location: {
      address: "Schijnpoortweg 119, 2170 Merksem",
      locationAndCameraDirection:
        "Camcar op parking P2 richting hoofdingang Sportpaleis — overzicht aankomst- en vertrekstromen.",
      polePresence: "needsToBePlaced",
      photos: [
        {
          id: "ph-9227-1",
          filename: "sportpaleis-luchtfoto.jpg",
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Afas-dome-luchtfoto-1.jpg/1280px-Afas-dome-luchtfoto-1.jpg",
          cameraDirection: "Luchtzicht Sportpaleis en omliggende parkings",
        },
      ],
      environmentalFactors:
        "Buitenparking, beperkte verlichting buiten openingsuren, veel voetgangers op piek.",
    },
    extraInfo: {
      event: "Ja",
      eventInfo:
        "Concertreeks grote zaal — 2 avonden, ~22.000 bezoekers per avond.",
      parkingSigns:
        "Plaatsing parkeerborden vereist voor camcar (zie politiezone).",
    },
    motivation: {
      reason: "Crowd management en preventief cameratoezicht bij grote massa.",
      pvNumber: "",
      specialAuthorization: "Niet van toepassing.",
      multipleDeployment: "1 camcar.",
      complianceConfirmed: true,
    },
    qualityConfirmed: true,
    caseId: "case-9227",
  },
  {
    id: "req-9229",
    number: "AANV-2026-9229",
    title: "ANPR-trailer Singel",
    status: "approved",
    requesterId: "u-maarten",
    submittedAt: "2026-04-25T10:00:00",
    requester: COMMON_REQUESTER,
    assets: [
      { id: "line-9229-1", assetType: "trailer", quantity: 1, note: "ANPR-trailer met signalisatie." },
    ],
    period: {
      startDate: "2026-05-01",
      deploymentStart: "2026-05-01",
      endDate: "2026-05-15",
      extensionPossible: true,
    },
    location: {
      address: "Singel 25, 2018 Antwerpen",
      locationAndCameraDirection:
        "ANPR-trailer ter hoogte van knooppunt Berchem Station, richting noordelijke rijbaan.",
      polePresence: "notApplicable",
      photos: [
        {
          id: "ph-9229-1",
          filename: "singel-berchem-station.jpg",
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Antwerp-Berchem_train_station_3.jpg/1280px-Antwerp-Berchem_train_station_3.jpg",
          cameraDirection: "Trailer op Singel richting Berchem Station",
        },
      ],
      environmentalFactors:
        "Drukke uitvalsweg, hoge verkeerssnelheden, trailer op vluchtstrook met signalisatie.",
    },
    extraInfo: {
      event: "Nee",
      eventInfo: "",
      parkingSigns: "Signalisatieplan in te dienen bij dienst mobiliteit.",
    },
    motivation: {
      reason:
        "ANPR-controle in kader van mobiliteitsplan — opvolging zware overtredingen en geseinde voertuigen.",
      pvNumber: "PV-2026-A-13702",
      specialAuthorization: "Niet van toepassing — reguliere ANPR-inzet.",
      multipleDeployment: "1 ANPR-trailer.",
      complianceConfirmed: true,
    },
    qualityConfirmed: true,
    caseId: "case-9229",
  },
  {
    id: "req-9199",
    number: "AANV-2026-9199",
    title: "Cameratoezicht Park Spoor Noord",
    status: "completed",
    requesterId: "u-maarten",
    submittedAt: "2026-03-05T08:30:00",
    requester: COMMON_REQUESTER,
    assets: [
      { id: "line-9199-1", assetType: "camera", quantity: 1 },
    ],
    period: {
      startDate: "2026-03-10",
      deploymentStart: "2026-03-10",
      endDate: "2026-04-08",
      extensionPossible: false,
    },
    location: {
      address: "Park Spoor Noord, 2060 Antwerpen",
      locationAndCameraDirection:
        "Camera op bestaande paal aan toegang Damplein — zicht op centrale wandelpaden.",
      polePresence: "yes",
      photos: [
        {
          id: "ph-9199-1",
          filename: "park-spoor-noord.jpg",
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Park_Spoor_Noord_-_bovenaanzicht.jpg/960px-Park_Spoor_Noord_-_bovenaanzicht.jpg",
          cameraDirection: "Bovenaanzicht park richting centrale paden",
        },
      ],
      environmentalFactors:
        "Open park, bomen langs randen, verlichting beperkt na 23u.",
    },
    extraInfo: {
      event: "Nee",
      eventInfo: "",
      parkingSigns: "Niet vereist.",
    },
    motivation: {
      reason:
        "Maandelijkse evaluatie cameratoezicht park — observatie nachtelijke samenscholingen.",
      pvNumber: "PV-2026-A-11014",
      specialAuthorization: "Niet van toepassing.",
      multipleDeployment: "1 mobiele camera.",
      complianceConfirmed: true,
    },
    qualityConfirmed: true,
    caseId: "case-9199",
  },
  {
    id: "req-9230",
    number: "AANV-2026-9230",
    title: "Sportpaleis avond 3 — extra camera",
    status: "submitted",
    requesterId: "u-maarten",
    submittedAt: "2026-05-09T16:08:00",
    requester: COMMON_REQUESTER,
    assets: [
      { id: "line-9230-1", assetType: "camcar", quantity: 1, note: "Aanvullende camcar op P3." },
    ],
    period: {
      startDate: "2026-05-14",
      endDate: "2026-05-14",
      extensionPossible: false,
    },
    location: {
      address: "Schijnpoortweg 119, 2170 Merksem",
      locationAndCameraDirection:
        "Tweede camcar op parking P3 ter ondersteuning, richting zij-ingang.",
      polePresence: "needsToBePlaced",
      photos: [
        {
          id: "ph-9230-1",
          filename: "sportpaleis-luchtfoto.jpg",
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Afas-dome-luchtfoto-1.jpg/1280px-Afas-dome-luchtfoto-1.jpg",
          cameraDirection: "Aanvulling op bestaande camcar — zij-ingang in beeld",
        },
      ],
      environmentalFactors: "Buitenparking, geen verlichting.",
    },
    extraInfo: {
      event: "Ja",
      eventInfo: "Aanvullende inzet bovenop AANV-2026-9227 — derde concertavond.",
      parkingSigns: "Plaatsing parkeerborden vereist voor camcar.",
    },
    motivation: {
      reason: "Bijkomende camera nodig na evaluatie eerste avonden.",
      pvNumber: "",
      specialAuthorization: "Niet van toepassing.",
      multipleDeployment: "1 extra camcar.",
      complianceConfirmed: true,
    },
    qualityConfirmed: true,
  },
  {
    id: "req-9231",
    number: "AANV-2026-9231",
    title: "Camera Theaterplein markten",
    status: "inReview",
    requesterId: "u-maarten",
    submittedAt: "2026-05-10T09:30:00",
    requester: COMMON_REQUESTER,
    assets: [
      { id: "line-9231-1", assetType: "camera", quantity: 1 },
    ],
    period: {
      startDate: "2026-05-15",
      endDate: "2026-06-30",
      extensionPossible: true,
    },
    location: {
      address: "Theaterplein, 2000 Antwerpen",
      locationAndCameraDirection:
        "Camera op bestaande paal hoek Komedieplaats, richting marktopstellingen.",
      polePresence: "yes",
      photos: [
        {
          id: "ph-9231-1",
          filename: "theaterplein-antwerpen.jpg",
          url: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/OlV_toren_en_Boerentoren_Antwerpen_vanaf_Linkeroever.jpg/1280px-OlV_toren_en_Boerentoren_Antwerpen_vanaf_Linkeroever.jpg",
          cameraDirection: "Overzicht stadscentrum vanaf Linkeroever — context",
        },
      ],
      environmentalFactors:
        "Wekelijkse vogelmarkt en boekenmarkt — drukke zaterdag- en zondagochtenden.",
    },
    extraInfo: {
      event: "Ja",
      eventInfo: "Vogelmarkt elke zondag, Boekenmarkt elke zaterdag.",
      parkingSigns: "Niet vereist.",
    },
    motivation: {
      reason:
        "Klachten zakkenrollerij en kleine criminaliteit tijdens marktdagen — gerichte preventieve camera.",
      pvNumber: "",
      specialAuthorization: "Niet van toepassing.",
      multipleDeployment: "1 mobiele camera.",
      complianceConfirmed: true,
    },
    qualityConfirmed: true,
  },
];
